import React from 'react';

type IframeProps = {
  src: string;
};

export default function IframeGame(props: IframeProps) {
  const { src } = props;

  return (
    <iframe
      id='vggd-id-ifrgame'
      className='vggd-ifr-game'
      src={src}
      title='vggd'></iframe>
  );
}
